import { render, staticRenderFns } from "./messageMenu.vue?vue&type=template&id=3c2c4512&scoped=true&"
import script from "./messageMenu.vue?vue&type=script&lang=js&"
export * from "./messageMenu.vue?vue&type=script&lang=js&"
import style0 from "./messageMenu.vue?vue&type=style&index=0&id=3c2c4512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c4512",
  null
  
)

export default component.exports